import React from 'react'
import Spinner from './Spinner'

export default function ActivityIndicator({waitFor, children}) {
  return (
    waitFor ? children : <Spinner />
  )
}
